/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CognitoResetPasswordResponseDto
 */
export interface CognitoResetPasswordResponseDto {
    /**
     * Human-readable result
     * @type {string}
     * @memberof CognitoResetPasswordResponseDto
     */
    message: string;
}

/**
 * Check if a given object implements the CognitoResetPasswordResponseDto interface.
 */
export function instanceOfCognitoResetPasswordResponseDto(value: object): value is CognitoResetPasswordResponseDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CognitoResetPasswordResponseDtoFromJSON(json: any): CognitoResetPasswordResponseDto {
    return CognitoResetPasswordResponseDtoFromJSONTyped(json, false);
}

export function CognitoResetPasswordResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoResetPasswordResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function CognitoResetPasswordResponseDtoToJSON(value?: CognitoResetPasswordResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
    };
}

